import { GetSingleDataSet } from "network/wineDataSetAPI";
import { useTranslation } from "react-i18next";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Button, Card } from "reactstrap";
import { useNavigate } from "react-router-dom";
import DataSetFrom from "./DataSetFrom";
import { ShowLoadingScreen } from "components/common/Loading";

export default function EditDatasetForm() {
  const { t } = useTranslation("wine");
  const navigate = useNavigate();
  const { id } = useParams();
  const [editData, setEditData] = useState({});
  const [isLoading, setIsLoading] = useState(true);

  async function getSingleData(editID) {
    try {
      const response = await GetSingleDataSet(editID);
      if (response.success) {
        setEditData(response.data);
      }
    } catch (errors) {
    } finally {
      setIsLoading(false);
    }
  }
  useEffect(() => {
    getSingleData(id);
  }, [id]);
  if (isLoading) {
    return <ShowLoadingScreen />;
  }
  return (
    <div className="content my-4">
      <Card className="p-4">
        <div className="d-flex mb-4 flex-wrap gap-16 justify-content-between align-items-center ">
          <Button
            onClick={() => navigate(-1)}
            className="btn btn-primary d-flex"
          >
            <i
              className="tim-icons icon-minimal-left
                  
                  font-weight-bold mr-2  font-size-xl"
            ></i>
            <span>{t("common.back")}</span>
          </Button>
          <h2 className="text-capitalize mb-0 ">{t("form.editTitle")}</h2>
        </div>

        {editData ? (
          <DataSetFrom editData={editData} />
        ) : (
          <p className="text-center">{t("form.notFound")}</p>
        )}
      </Card>
    </div>
  );
}
